import { NgModule } from '@angular/core';
import { SharedProviderModule } from '../../shared/shared.module';
import { OverlayPanelComponent } from './overlay-panel.component';

@NgModule({
  imports: [
    SharedProviderModule
  ],
  declarations: [OverlayPanelComponent],
  exports: [OverlayPanelComponent]
})
export class OverlayPanelModule {
}
